module.exports = __webpack_public_path__ + "static/media/blog-4.1e7a93d4.jpg";